/**
 * How long a toast stays (components.md 11, native DBToast.duration): two
 * seconds at least, one more second for every 20 characters past 40. A
 * caller's own duration wins when it is longer. Native doubles it under
 * VoiceOver; the web cannot tell, so the role="status" announcement carries it.
 */
export function toastDuration(message: string, requested?: number): number {
  const extra = Math.max(0, Math.ceil((message.length - 40) / 20));
  const rule = 2000 + extra * 1000;
  return requested && requested > rule ? requested : rule;
}
